import { TextInput } from "@strapi/design-system";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const Prizesv2 = ({ data, setData }) => {
  const { t } = useTranslation();

  const handleChangeUrl = (url) => {
    setData({ ...data, url });
  };

  const handleSetName = (name) => {
    if (data?.key) {
      setData({ ...data, name });
    } else {
      setData({ ...data, name, key: dayjs().format("x") });
    }
  };

  return (
    <div>
      <TextInput
        label={t("str_proof_of_ability")}
        name="name"
        value={data?.name || ""}
        onChange={(e) => handleSetName(e.target.value)}
      />
      <br />
      <TextInput
        label={t("str_attach_link")}
        name="url"
        value={data?.url || ""}
        onChange={(e) => handleChangeUrl(e.target.value)}
      />
    </div>
  );
};

export default Prizesv2;
